/**
 * Dashboard — main admin overview page for flowstate-start.
 *
 * Amalgamated with Nexus: renders the unified NexusDashboard component.
 */

import { createFileRoute, redirect } from "@tanstack/react-router";
import { createRouteError } from "../../../components/RouteErrorBoundary";
import { StatsRowSkeleton } from "../../../components/RouteSkeleton";
import { systemStatsKeys } from "../../../hooks/useSystemStats";
import { getSystemStats } from "../../../server/stats";
import NexusDashboard from "../../../pages/Admin/Nexus";

export const Route = createFileRoute("/_admin/dashboard/")({
  beforeLoad: async ({ context }) => {
    if (typeof window === "undefined") return {};
    const sb = context.supabase;
    if (!sb) return {};
    const {
      data: { session },
    } = await sb.auth.getSession();
    if (!session) {
      throw redirect({ to: "/auth" });
    }
    return { session };
  },
  loader: async ({ context: { queryClient } }) => {
    await queryClient.ensureQueryData({
      queryKey: systemStatsKeys.stats(),
      queryFn: async () => {
        const result = await getSystemStats({ data: {} });
        if (result.error) throw new Error(`Failed to load system stats: ${result.error}`);
        return result.data;
      },
      staleTime: 1000 * 60 * 5,
    });
  },
  pendingComponent: () => (
    <div className="space-y-8 pb-8 p-6">
      <div className="h-10 w-64 rounded bg-muted animate-pulse" />
      <StatsRowSkeleton count={4} />
    </div>
  ),
  errorComponent: createRouteError("Dashboard"),
  component: NexusDashboard,
});
